var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import { getBasicMetricInfos } from '@/clients/admin';
import InfosetsTableTab from '@/modules/admin/components/AccountManagementModal/AccountManagementUserBehaviorTab/InfosetsTableTab.vue';
import OnlineDaysTableTab from '@/modules/admin/components/AccountManagementModal/AccountManagementUserBehaviorTab/OnlineDaysTableTab.vue';
import EventHistoryTableTab from '@/modules/admin/components/AccountManagementModal/AccountManagementUserBehaviorTab/EventHistoryTableTab.vue';
import FiltersUsedOnSearchTableTab from '@/modules/admin/components/AccountManagementModal/AccountManagementUserBehaviorTab/FiltersUsedOnSearchTableTab.vue';
import NpsScoreTableTab from '@/modules/admin/components/AccountManagementModal/AccountManagementUserBehaviorTab/NpsScoreTableTab.vue';
const PERIOD_STORAGE_KEY = 'atlas.admin.user_behavior.period_days';
const PERIOD_OPTIONS = [
    { label: '1 mês', value: 30 },
    { label: '3 meses', value: 90 },
    { label: '6 meses', value: 180 },
];
let AccountManagementUserBehaviorTabContainer = class AccountManagementUserBehaviorTabContainer extends Vue {
    constructor() {
        super(...arguments);
        this.basicMetricInfos = {
            infosets_created_last_thirty_days: 0,
            used_exportation_credits: 0,
            used_click_credits: 0,
            healthscore: { score: 0, category: '' },
            cs: '',
            onboarding: { user_selected_option: '' },
        };
        this.selectedDays = 30;
        this.periodOptions = PERIOD_OPTIONS;
        this.filterShowBy = 'infosets';
        this.toggleOptions = [
            { value: 'infosets', slot: 'infosets' },
            { value: 'events-history', slot: 'events-history' },
            { value: 'online-days', slot: 'online-days' },
            {
                value: 'filters-used-in-each-search',
                slot: 'filters-used-in-each-search',
            },
            { value: 'nps-scores', slot: 'nps-scores' },
        ];
    }
    async mounted() {
        const persisted = this.readPersistedDays();
        if (persisted)
            this.selectedDays = persisted;
        await this.fetchBasicMetricInfos();
    }
    async fetchBasicMetricInfos() {
        const accountId = this.$store.getters['admin/get_selected_account'];
        const response = await getBasicMetricInfos(accountId, this.selectedDays);
        if (response && response.status == 200 && response.data) {
            this.basicMetricInfos = response.data;
        }
    }
    onPeriodChange(value) {
        this.selectedDays = value;
        this.persistDays(value);
        this.fetchBasicMetricInfos();
    }
    readPersistedDays() {
        try {
            const raw = window.localStorage.getItem(PERIOD_STORAGE_KEY);
            const parsed = raw ? parseInt(raw, 10) : NaN;
            return PERIOD_OPTIONS.some(o => o.value === parsed)
                ? parsed
                : null;
        }
        catch (e) {
            return null;
        }
    }
    persistDays(value) {
        try {
            window.localStorage.setItem(PERIOD_STORAGE_KEY, String(value));
        }
        catch (e) {
            /* storage indisponível: ignora */
        }
    }
    get periodLabel() {
        const opt = PERIOD_OPTIONS.find(o => o.value === this.selectedDays);
        return opt ? `(${opt.label})` : '';
    }
    formatOnboardingStatus(onboarding_status) {
        if (!onboarding_status)
            return 'Não fez';
        const status = {
            already_done: 'Já fez',
            scheduled: 'Marcado',
            refused: 'Recusado',
        };
        return status[onboarding_status.user_selected_option];
    }
    get healthscore() {
        if (this.basicMetricInfos && this.basicMetricInfos.healthscore) {
            const hs = this.basicMetricInfos.healthscore;
            return `${hs['category']} (${hs['score']})`;
        }
        else {
            return '';
        }
    }
};
AccountManagementUserBehaviorTabContainer = __decorate([
    Component({
        name: 'AccountManagementUserBehaviorTabContainer',
        components: {
            InfosetsTableTab,
            OnlineDaysTableTab,
            EventHistoryTableTab,
            FiltersUsedOnSearchTableTab,
            NpsScoreTableTab,
        },
    })
], AccountManagementUserBehaviorTabContainer);
export default AccountManagementUserBehaviorTabContainer;
